/**
 * Keep the current protected follower/following page intact while the
 * realtime runtime refetches it from the server. Notification payloads carry
 * identity snapshots that predate the viewer's latest block state, so they
 * must never be admitted directly into a viewer-sensitive cache.
 */
export function keepFollowerListUntilProtectedRefetch<T>(
  previous: T,
  _event: Record<string, unknown>,
  _args?: Record<string, unknown>,
): T {
  return previous;
}
